const defaultBreakpoints = {
  xs: null,
  sm: '(min-width: 576px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 992px)',
  xl: '(min-width: 1200px)',
}
export default defaultBreakpoints
